// layout/index.jsx (or Main.jsx)
// 📍 Location: frontend/layout/index.jsx

import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Drawer, Affix } from "antd";
import { useSelector } from "react-redux";

import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import LocationSelector from "../components/LocationSelector"; // ✅ IMPORT
import { ROLE } from "../constant";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);

  // ✅ Get user locations — switcher is owner-only
  const user = useSelector((state) => state.app.user);
  const locations = user?.locationIds || [];
  const isOwner =
    user?.role === ROLE.RESTAURANT_ADMIN || user?.role === ROLE.SUPER_ADMIN;
  const hasMultipleLocations = isOwner && locations.length > 1;

  const openDrawer = () => setVisible((e) => !e);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
    setVisible(false);
  }, [pathname]);

  return (
    <Layout
      className={`layout-dashboard ${
        pathname === "profile" ? "layout-profile" : ""
      } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
    >
      <Drawer
        title={false}
        placement={placement === "right" ? "left" : "right"}
        closable={false}
        onClose={() => setVisible(false)}
        open={visible}
        key={placement === "right" ? "left" : "right"}
        width={250}
        className={`drawer-sidebar ${
          pathname === "rtl" ? "drawer-sidebar-rtl" : ""
        } `}
      >
        <Layout
          className={`layout-dashboard ${
            pathname === "rtl" ? "layout-dashboard-rtl" : ""
          }`}
        >
          <Sider
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${
              sidenavType === "#fff" ? "active-route" : ""
            }`}
            style={{ background: "rgb(109, 179, 63)", textAlign: "center" }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
        </Layout>
      </Drawer>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
        trigger={null}
        width={250}
        theme="light"
        className={`sider-primary ant-layout-sider-primary ${
          sidenavType === "#fff" ? "active-route" : ""
        }`}
        style={{ background: "rgb(109, 179, 63)", textAlign: "center" }}
      >
        <Sidenav color={sidenavColor} onPress={openDrawer} />
      </Sider>
      <Layout>
        {fixed ? (
          <Affix>
            <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
              <Header
                onPress={openDrawer}
                name={pathname}
                subName={pathname}
                handleSidenavColor={handleSidenavColor}
                handleSidenavType={handleSidenavType}
                handleFixedNavbar={handleFixedNavbar}
              />
            </AntHeader>
          </Affix>
        ) : (
          <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
            <Header
              onPress={openDrawer}
              name={pathname}
              subName={pathname}
              handleSidenavColor={handleSidenavColor}
              handleSidenavType={handleSidenavType}
              handleFixedNavbar={handleFixedNavbar}
            />
          </AntHeader>
        )}
        <Content className="content-ant">
          {/* ✅ ADD LOCATION SELECTOR INSIDE CONTENT (TOP) */}
          {hasMultipleLocations && (
            <div style={{ 
              padding: '16px 24px', 
              background: '#fff', 
              borderBottom: '1px solid #f0f0f0',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}>
              <LocationSelector />
            </div>
          )}
          {children}
        </Content>
        <Footer />
      </Layout>
    </Layout>
  );
}

export default Main;